import { stringContains } from "../../aplUtils/stringUtills";
import { browser } from "../../aplUtils/browserHelper";
import Select, { ActionMeta, GroupBase, OptionsOrGroups, StylesConfig } from "react-select";
import './ReactSelectWrapper.css';
export interface IReactSelectOption {
    label: string;
    value: any;
    disabled?: boolean;
}

export interface IReactSelectWrapperProps {
    data: IReactSelectOption[];
    isClearable?: boolean | undefined;
    styles?: StylesConfig<any, false, GroupBase<unknown>> | undefined;
    onChange?: ((newValue: any, actionMeta: ActionMeta<any>) => void) | undefined;
    value?: any;
    isDisabled?: boolean | undefined;
    id?: string;
};

export default function ReactSelectWrapper(props: IReactSelectWrapperProps) {
    const options: OptionsOrGroups<unknown, GroupBase<unknown>> | undefined =
        props.data == null || props.data.length === 0
            ? []
            : props.data.map((x: IReactSelectOption) => ({
                  value: x.value,
                  label: x.label.toString(),
                  isDisabled: x.disabled
              }));
    return (
        <Select
            {...props}
            id={props.id}
            options={options}
            isClearable={props.isClearable}
            styles={props.styles}
            className="react-select-container"
            classNamePrefix={`${stringContains(browser.name, "firefox") && browser.version < 52 ? "react-select-ff40" : "react-select"}`}
            onChange={props.onChange}
            value={props.value}
            isDisabled={props.isDisabled}
        />
    );
}
